import * as Weirwood from '@baidu/weirwood-sdk';
import WeirwoodOptions from '../../../../weirwood.json';

function createError(type, message) {
    function MyError(type, message) {
        // name 会出现在平台 JS 异常列表的第一列 「类型」列，建议简洁清晰。
        this.name = type || 'customError';
        this.message = message || 'Default Message';
        this.stack = (new Error()).stack;
    }
    MyError.prototype = Object.create(Error.prototype);
    MyError.prototype.constructor = MyError;

    const myError = new MyError(type, JSON.stringify(message));
    return myError;
}

const options = {
    common: {
        // 只支持如下字符：英文字母(大小写)，数字(0-9)，下划线(_)，中划线(-)，点(.)，@符号
        buildid: WeirwoodOptions.buildid,
        token: WeirwoodOptions.token,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            'local.baidu.com'
        ]
    },
    error: {
        collectWindowErrors: true,
        // promise异常
        collectUnhandledRejections: true,
        // 静态资源加载异常
        collectResourceLoadErrors: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            'local.baidu.com'
        ]
    },
    perf: {
        sampleRate: 1,
        spa: true,
        history: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            'local.baidu.com'
        ],
        // 轮询接口不上报性能日志，减少weirwoods预算
        ignoreXhrs: [
            'ai_anchor/round/info',
            'ai_anchor/notice_center/unread_num'
        ],
        // TTI指标忽略部分不影响用户交互时间的接口
        ttiWaitForXHRIgnore: () => {
            const baseIgnoreSource = [
                // 轮询接口
                'ai_anchor/notice_center/unread_num',
                'ai_anchor/round/info',
                // pass的二维码轮询刷新
                'channel/unicast',
                // 日志接口
                'fclog.baidu.com',
                'weirwood'
            ];
            return baseIgnoreSource;
        },
        // 开启交互性能上报
        afterOnload: true,
        initiatorTypes: ['spa_hard', 'spa', 'xhr', 'interaction']
    },
};

const initWeirwood = () => {
    return Weirwood.init(options);
};

function captureException(error) {
    if (process.env.NODE_ENV === 'production' && location.hostname === 'huibo.baidu.com') {
        if (window.__Weirwood && window.__Weirwood.error && window.__Weirwood.error.captureException) {
            window.__Weirwood.error.captureException(error);
        }
    }
}
function captureAPIException(data) {
    if (process.env.NODE_ENV === 'production' && location.hostname === 'huibo.baidu.com') {
        if (window.__Weirwood && window.__Weirwood.error && window.__Weirwood.error.captureAPIException) {
            window.__Weirwood.error.captureAPIException({
                ...data,
                url: data.url || '',
                method: data.method || '',
                status: data.status || ''
            });
        }
    }
}


function customCaptureException(type, message) {
    if (process.env.NODE_ENV === 'production' && location.hostname === 'huibo.baidu.com') {
        if (window.__Weirwood && window.__Weirwood.error && window.__Weirwood.error.captureException) {
            const newError = createError(type, message);
            window.__Weirwood.error.captureException(newError);
        }
    }
}

function prefAddUserTiming(logParams) {
    if (process.env.NODE_ENV === 'production' && location.hostname === 'huibo.baidu.com') {
        if (window.__Weirwood && window.__Weirwood.perf && window.__Weirwood.perf.addUserTiming) {
            window.__Weirwood.perf.addUserTiming({...logParams});
        }
    }
}

export {
    initWeirwood,
    captureException,
    captureAPIException,
    customCaptureException,
    prefAddUserTiming
};
